const requiredEnvKeys = ['REACT_APP_API_URL'] as const;

const sameOriginProductionHosts = new Set([
  'true-karat.com',
  'www.true-karat.com',
  'jewelery-front-end.vercel.app',
]);

type ApiUrlConfig = {
  configuredApiUrl?: string;
  hostname?: string;
  nodeEnv?: string;
  origin?: string;
};

const validateUrl = (key: string, value?: string) => {
  if (!value) return false;

  try {
    new URL(value);
    return true;
  } catch {
    throw new Error(`${key} must be a valid URL.`);
  }
};

export const validateFrontendEnv = () => {
  const missing = requiredEnvKeys.filter((key) => !process.env[key]);

  if (missing.length) {
    throw new Error(`Missing frontend environment variables: ${missing.join(', ')}`);
  }

  validateUrl('REACT_APP_API_URL', process.env.REACT_APP_API_URL);

  if (process.env.NODE_ENV === 'production' && !process.env.REACT_APP_API_URL?.startsWith('https://')) {
    throw new Error('REACT_APP_API_URL must use HTTPS in production.');
  }
};

export const resolveApiUrl = ({
  configuredApiUrl,
  hostname,
  nodeEnv,
  origin,
}: ApiUrlConfig) => {
  if (
    nodeEnv === 'production' &&
    hostname &&
    origin &&
    sameOriginProductionHosts.has(hostname)
  ) {
    return new URL('/api/graphql', origin).toString();
  }

  return configuredApiUrl || '';
};

export const getApiUrl = () => {
  const browserLocation = typeof window !== 'undefined' ? window.location : undefined;

  return resolveApiUrl({
    configuredApiUrl: process.env.REACT_APP_API_URL,
    hostname: browserLocation?.hostname,
    nodeEnv: process.env.NODE_ENV,
    origin: browserLocation?.origin,
  });
};

export const apiUrl = getApiUrl();
